import React, { useRef } from 'react';
import './App.css';
import { AuthProvider } from './components/AuthContext';
import { PlaceIdProvider } from './contexts/PlaceContext';
import { Container, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DatePicker from './components/DatePicker';
import Header from './components/Header';
import { themeOptions } from './components/ThemeOption.ts';
import { NotificationProvider } from './components/NotificationContext';
import Profile from './components/Profile';
import Booking from './components/Bookings';
import Trainings from './components/Trainings';
import BottomNavi from './components/BottomNavi';
import Policy from './components/Policy';
import Privacy from './components/Privacy';
import { NotificationApiHook } from './components/NotificationApiHook';
import PlacePicker from './components/PlacePicker';
import SharedDoor from './components/SharedDoor';
import PlacePickerReroute from './components/PlacePickerReroute';
import AdminPanel from './components/admin/AdminPanel';

const theme = createTheme(themeOptions);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <NotificationApiHook>
          <AuthProvider>
            <PlaceIdProvider>
              <CssBaseline />
              <Router>
                <Header />
                <PlacePickerReroute />
                <Container maxWidth='sm'>
                  <Routes>
                    <Route
                      path='/booking'
                      element={<DatePicker />}
                    />
                    <Route
                      path='/trainings'
                      element={<Trainings />}
                    />
                    <Route
                      path='/books'
                      element={<Booking />}
                    />
                    <Route
                      path='/profile'
                      element={<Profile />}
                    />
                    <Route
                      path='/privacy-policy'
                      element={<Privacy />}
                    />
                    <Route
                      path='/club-policy'
                      element={<Policy />}
                    />
                    <Route
                      path='/shared/:pwd'
                      element={<SharedDoor />}
                    />
                    <Route
                      path='/admin-panel'
                      element={<AdminPanel />}
                    />
                    <Route
                      path='/pick-place'
                      element={<PlacePicker />}
                    />
                  </Routes>
                </Container>
                <BottomNavi />
              </Router>
            </PlaceIdProvider>
          </AuthProvider>
        </NotificationApiHook>
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default App;
